<template lang="pug">
  .input-group
    input.form-control(:value="value" :class="{'input-error' : error}" :placeholder="placeholder" :disabled="disabled" @input="onSelected($event.target.value)" type="text")
    span.input-group-addon.hoverable(@click="clear" :disabled="disabled") X
</template>
<script>
import Flatpickr from 'flatpickr'

require('flatpickr/dist/flatpickr.css')

export default {
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    timePicker: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select a date'
    },
    label: {
      type: String,
      required: false
    }
  },
  mounted() {
    const element = this.$el.querySelector('.input-group > input[type="text"]')
    this.flatpickr = new Flatpickr(element, {
      enableTime: this.timePicker,
      dateFormat: this.timePicker ? 'Y-m-dTH:i' : 'Y-m-d',
      allowInput: true,
      altInput: true,
      time_24hr: true,
      defaultDate: this.value,
      errorHandler: () => ({})
    })
  },
  beforeDestroy() {
    this.flatpickr.destroy()
  },
  watch: {
    value() {
      this.flatpickr.setDate(this.value)
    },
    error() {
      const element = this.$el.querySelector('.input-group > input[type="text"]')
      if (!this.error) {
        element.classList.remove('input-error')
      } else {
        element.classList.add('input-error')
      }
    }
  },
  methods: {
    onSelected(val) {
      const date = new Date(val)
      if (val !== null) {
        this.$emit('input', date)
      } else {
        this.clear()
      }
    },
    clear() {
      this.flatpickr.setDate(null)
      this.$emit('input', null)
      this.close()
    },
    close() {
      this.flatpickr.close()
    }
  },
  components: {
    Flatpickr
  }
}
</script>



// WEBPACK FOOTER //
// src/components/metadataeditor/template/MetadataDatePicker.vue